<template>
	<div class="schedule-content">
		<div class="row px-3 pt-2 pb-0" v-if="isFetchingSchedule">
			<div class="col-md-12">
				<div class="table-fetch-schedule text-align-center mt-5 pt-4">
					<div class="is-loading large dark m-auto"></div>
				</div>
			</div>
		</div>
		<div class="row px-3 pt-2 pb-0" v-else>
			<div class="col-md-12">
				<div class="table-responsives">
					<table class="table">
						<thead>
							<tr>
								<th class="border-top-0" width="10%">{{ $t('members.schedule.status') }}</th>
								<th class="border-top-0">{{ $t('members.schedule.day') }}</th>
								<th class="border-top-0">{{ $t('members.schedule.start') }}</th>
								<th class="border-top-0">{{ $t('members.schedule.end') }}</th>
							</tr>
						</thead>
						<tbody>
							<template v-if="schedule !== null">
								<members-schedule-form v-bind:schedule.sync="schedule.monday" day="monday" />
								<members-schedule-form v-bind:schedule.sync="schedule.tuesday" day="tuesday" />
								<members-schedule-form v-bind:schedule.sync="schedule.wednesday" day="wednesday" />
								<members-schedule-form v-bind:schedule.sync="schedule.thursday" day="thursday" />
								<members-schedule-form v-bind:schedule.sync="schedule.friday" day="friday" />
								<members-schedule-form v-bind:schedule.sync="schedule.saturday" day="saturday" />
								<members-schedule-form v-bind:schedule.sync="schedule.sunday" day="sunday" />
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<div class="col-sm-12 px-0">
				<button class="btn btn-light" v-on:click.stop.prevent="close">{{ $t('global.close') }}</button>
				<button class="btn btn-primary" type="submit" :disabled="isFetchingSchedule" @click="applySchedule" :class="{ 'is-loading': isLoading }">{{ $t('global.save') }}</button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import MembersScheduleForm from './MembersScheduleForm.vue';
import teamApi from '../api/team';

export default {
	name: 'membersSchedule',
	props: {
		id: {
			type: String,
		},
	},
	components: {
		MembersScheduleForm,
	},
	data() {
		return {
			isLoading: false,
			newSchedule: {},
		};
	},
	computed: {
		...mapGetters({
			schedule: 'members/schedule',
			isFetchingSchedule: 'members/isFetchingSchedule',
		}),
	},
	created() {},
	methods: {
		close() {
			this.$emit('close');
		},
		applySchedule() {
			this.isLoading = true;
			const id = this.id;
			const params = {
				schedule: JSON.stringify(this.schedule),
			};

			const callback = () => {
				this.isLoading = false;
				this.close();

				this.$notify({
					group: 'members',
					title: 'Members',
					text: 'Members Schedule Updated',
					type: 'success',
				});
			};

			const errorCallback = (err) => {
				this.isLoading = false;
				// eslint-disable-next-line
				console.log('err tag', err);

				this.$notify({
					group: 'members',
					title: 'Members',
					text: 'Error Updated',
					type: 'danger',
				});
			};

			teamApi.updateSchedule(id, params, callback, errorCallback);
		},

	},
	watch: {},
	destroyed() {},
};
</script>
<style scoped>
.table-fetch-schedule {
	min-height: 120px;
}
</style>
